import { TokenInfo } from '@/generated/proto/bridge/models/token'
import { ProtobufAnyMessage } from '@/types'

export type AddTokenInfoFormValues = {
  creator: string
  selectedTokenId?: string
  selectedChainId?: string
  info: {
    address: string
    decimals: string
    chainId: string
    tokenId: string
    isWrapped: boolean
    minWithdrawalAmount: string
    commissionRate: string
  }
}

export type RemoveTokenInfoFormValues = {
  creator: string
  selectedTokenId?: string
  selectedChainId?: string
  tokenId: string
  chainId: string
}

export function buildAddTokenInfoMessage(values: AddTokenInfoFormValues): {
  messages: ProtobufAnyMessage[]
} {
  const info: TokenInfo = {
    address: values.info.address,
    decimals: values.info.decimals,
    chainId: values.info.chainId,
    tokenId: values.info.tokenId,
    isWrapped: values.info.isWrapped,
    minWithdrawalAmount: values.info.minWithdrawalAmount,
    commissionRate: values.info.commissionRate,
  }

  return {
    messages: [
      {
        '@type': '/core.bridge.MsgAddTokenInfo',
        creator: values.creator,
        info,
      },
    ],
  }
}

export function buildRemoveTokenInfoMessage(
  values: RemoveTokenInfoFormValues,
): {
  messages: ProtobufAnyMessage[]
} {
  return {
    messages: [
      {
        '@type': '/core.bridge.MsgRemoveTokenInfo',
        creator: values.creator,
        tokenId: values.tokenId,
        chainId: values.chainId,
      },
    ],
  }
}
